module.exports = __webpack_public_path__ + "components/page-header/static/icon-resort-69133c4c8e147746b15f5d912959b053.svg";